import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Trans, useTranslation } from 'next-i18next';
import { AirportListItem } from '../../../../../../../../../../components/SearchForm/components/AirportsWidget/components/AirportListItem.js';
import { Controls } from '../../../../../../../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/components/List/components/Item/components/Controls/index.js';
import { HighlightedText } from '../../../../../../../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/components/List/components/Item/components/HighlightedText/index.js';
import { getNearbyAirportCodes, isAllAirportNearbyChecked } from '../../../../../../../../../../components/SearchForm/components/AirportsWidget/utils/nearbyAirports.js';
import { Checkbox, CollapsibleSection, LabelMedium, LabelMediumBold, LabelXSmall, Stack } from '../../../../../../../../../../primitives/index.js';
import { SPACING_SMALL, SPACING_XSMALL } from '../../../../../../../../../../utils/spacingLegacy.js';
export const Item = ({
  toggleExpand,
  isExpanded,
  item,
  isChecked,
  onCheck,
  value
}) => {
  const {
    t
  } = useTranslation();
  const nearbyCodes = getNearbyAirportCodes(item);
  const isMainItemChecked = isAllAirportNearbyChecked(item, isChecked);
  const hasNearby = !!item.nearby && item.nearby?.length > 0;
  return _jsxs(Stack, {
    spacing: SPACING_SMALL,
    children: [_jsx(Checkbox, {
      value: hasNearby ? nearbyCodes : item.code,
      checked: hasNearby ? isMainItemChecked : isChecked(item.code),
      label: _jsx(Stack, {
        direction: "row",
        alignItems: "baseline",
        spacing: SPACING_SMALL,
        children: hasNearby ? _jsx(LabelMediumBold, {
          children: _jsx(Trans, {
            i18nKey: "airportsWidget:nearBy",
            components: {
              name: _jsx(HighlightedText, {
                text: t(`airportsWidget:options.${item.code}.name`),
                query: value
              })
            }
          })
        }) : _jsx(LabelMedium, {
          children: _jsx(HighlightedText, {
            text: t(`airportsWidget:options.${item.code}.name`),
            query: value
          })
        })
      }),
      onChange: onCheck
    }), hasNearby && _jsx(CollapsibleSection, {
      maxVisibleItems: 4,
      expanded: isExpanded,
      controls: _jsx(Controls, {
        expanded: isExpanded,
        onClick: toggleExpand
      }),
      expandable: true,
      children: item.nearby?.map((nearbyItem, nearbyIndex) => _jsx(AirportListItem, {
        children: _jsx(Checkbox, {
          value: nearbyItem.code,
          checked: isChecked(nearbyItem.code),
          label: _jsxs(Stack, {
            direction: "row",
            alignItems: "baseline",
            spacing: SPACING_SMALL,
            children: [t(`airportsWidget:options.${nearbyItem.code}.name`), _jsx(LabelXSmall, {
              truncate: true,
              color: "contentTertiary",
              children: _jsx(HighlightedText, {
                text: nearbyItem.code,
                query: value
              })
            }), _jsx(Stack, {
              direction: "row",
              spacing: SPACING_XSMALL,
              children: _jsxs(LabelXSmall, {
                truncate: true,
                color: "contentTertiary",
                children: [nearbyItem.distance, t(`airportsWidget:distance`)]
              })
            })]
          }),
          onChange: onCheck
        })
      }, nearbyIndex))
    })]
  });
};